module.exports = __webpack_public_path__ + "static/img/video_big_icon.b151d3bb.png";